import { render, staticRenderFns } from "./localStoreInfo.vue?vue&type=template&id=2aba1d6e&scoped=true&"
import script from "./localStoreInfo.vue?vue&type=script&lang=js&"
export * from "./localStoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./localStoreInfo.vue?vue&type=style&index=0&id=2aba1d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba1d6e",
  null
  
)

export default component.exports